export const DBStateKey = 'db';
